"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M2 0v4c0 2.97 2.16 5.43 5 5.91V14H5c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1H9V9.91c2.84-.48 5-2.94 5-5.91V0H2z"];
//# sourceMappingURL=glass.js.map